module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ../hyperdb-utils/~/babel-runtime/~/core-js/library/modules/_html.js
// module id = 770
// module chunks = 0